import { render } from "./HomeBlog.vue?vue&type=template&id=9537c90c"
import script from "./HomeBlog.vue?vue&type=script&lang=js"
export * from "./HomeBlog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\code repo\\iebrewers.org\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__